import React, { useState } from "react";
import {
  Button,
  ShowProps,
  useDataProvider,
  useMutation,
  useNotify,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import SanitizedGrid from "components/SanitizedGrid";
import {
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { GetParam } from "utils/tools";
import { GridinRow, GridinRowsWithSpace, GridLabel } from "utils/style";
import { useEffect } from "react";
import _ from "lodash";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    padding: "1rem",
    marginTop: "20px",
  },
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
});

const Address = (props: ShowProps) => {
  const [addresses, setAddresses] = useState<IStudentAddress[]>([]);
  const [mainAddresses, setMainAddresses] = useState<IStudentAddress[]>([]);
  const [subAddresses, setSubAddresses] = useState<IStudentAddress[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const provider = useDataProvider();
  const classes = useStyles();
  const param = GetParam();
  const { id } = props;

  const getStudentAddresses = () => {
    setLoading(true);
    provider
      .getList("studentaddresses", {
        filter: { StudentId: Number(id) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then(({ data }) => {
        setAddresses(data as IStudentAddress[]);
        setLoading(false);
      });
  };

  useEffect(() => {
    getStudentAddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setMainAddresses(_.filter(addresses, ["isMain", true]));
    setSubAddresses(_.filter(addresses, ["isMain", false]));
  }, [addresses]);

  const ChangeMainAddressButton = (props: { addressId: number }) => {
    const notify = useNotify();

    const [handleChangeMainAddress, { loading }] = useMutation(
      {
        type: "customUpdate",
        resource: `StudentAddresses/${props.addressId}/setMain`,
        payload: {
          data: { studentId: id },
        },
      },
      {
        onSuccess: ({ data }) => {
          notify(`Successfully change main address.`, "info");
          getStudentAddresses();
        },
        onFailure: (error) =>
          notify(`Failed change status, error: ${error.message}`, "warning"),
      }
    );

    return (
      <Button
        label={loading ? `Loading...` : `Set to Main`}
        onClick={handleChangeMainAddress}
      />
    );
  };

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12} style={GridinRowsWithSpace}>
        <Typography variant="h6">Main Address</Typography>

        <Button
          onClick={() =>
            props.history.push(
              `/studentAddresses/create?source=${JSON.stringify({
                studentId: Number(id),
              })}&studentId=${Number(id)}${
                param.get("parentId")
                  ? `&parentId=${param.get("parentId")}`
                  : ""
              }`
            )
          }
          label="Create New Address"
        >
          <IconPlus />
        </Button>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>#ID</TableCell>
                <TableCell>Postal Code</TableCell>
                <TableCell>Addresses</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mainAddresses.length > 0 ? (
                <>
                  {mainAddresses.map((address: IStudentAddress) => {
                    return (
                      <TableRow>
                        <TableCell>{address.id}</TableCell>
                        <TableCell>{address.postalCode}</TableCell>
                        <TableCell>
                          <SanitizedGrid container spacing={2}>
                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Block No. : {address.blockNumber}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Street : {address.street}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Unit No : {address.unitNumber}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Building Name : {address.building}
                              </Typography>
                            </Grid>
                          </SanitizedGrid>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    {loading ? "Loading..." : "No results found."}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Sub Address</Typography>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>#ID</TableCell>
                <TableCell>Postal Code</TableCell>
                <TableCell>Addresses</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subAddresses.length > 0 ? (
                <>
                  {subAddresses.map((address: IStudentAddress) => {
                    return (
                      <TableRow>
                        <TableCell>{address.id}</TableCell>
                        <TableCell>{address.postalCode}</TableCell>
                        <TableCell>
                          <SanitizedGrid container spacing={2}>
                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Block No. : {address.blockNumber}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Street : {address.street}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Unit No : {address.unitNumber}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} style={GridinRow}>
                              <Typography variant="body2" style={GridLabel}>
                                Building Name : {address.building}
                              </Typography>
                            </Grid>
                          </SanitizedGrid>
                        </TableCell>
                        <TableCell>
                          <ChangeMainAddressButton addressId={address.id} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={5}>Record not found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </SanitizedGrid>
  );
};

export default Address;
